import * as IconSelector from '../icons';

// Constantes exportadas
export const STATE_ACTIVO_DISPONIBLE = 'Disponible';
export const STATE_ACTIVO_EN_USO = 'En uso';
export const STATE_ACTIVO_BAJA = 'Baja';

// Definición del enum
export const statesAsset = [
    {
        value: null,
        label: 'Sin definir',
        description: 'No se ha definido un estado',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: STATE_ACTIVO_DISPONIBLE,
        label: 'Disponible',
        description: 'Estado disponible',
        icon: IconSelector.AvailableIcon,
        color: 'Green'
    },
    {
        value: STATE_ACTIVO_EN_USO,
        label: 'En uso',
        description: 'Estado en uso',
        icon: IconSelector.InstalledIcon,
        color: 'Blue'
    },
    {
        value: STATE_ACTIVO_BAJA,
        label: 'Baja',
        description: 'Estado Baja',
        icon: IconSelector.DoneIcon,
        color: 'DarkRed'
    }
];
